import React from 'react'
import { Flex } from 'antd'
import EditQuestionForm from '../EditQuestionForm'

const PropertiesTab = ({ form }) => {
    return (
        <Flex vertical>
            <EditQuestionForm form={form} />
        </Flex>
    )
}

export default PropertiesTab